import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  const go = (path: string) => navigate(path);

  return (
    <footer className="w-full bg-background-100 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <button
              onClick={() => go("/")}
              className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-extrabold text-foreground-950">
                笨狗漫画网
              </span>
            </button>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              每日更新列表一目了然，最新漫画、连载、完结作品随时掌握。追更不迷路，快速找到你想看的漫画。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {[
                { label: "首页", path: "/" },
                { label: "今日更新", path: "/updates" },
                { label: "漫画分类", path: "/comics" },
                { label: "关于我们", path: "/about" },
              ].map((item) => (
                <li key={item.path}>
                  <button
                    onClick={() => go(item.path)}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">热门分类</h4>
            <ul className="mt-4 space-y-2.5">
              {["热血冒险", "奇幻异能", "悬疑推理", "科幻机甲"].map((cat) => (
                <li key={cat}>
                  <button
                    onClick={() => go(`/comics?cat=${encodeURIComponent(cat)}`)}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
                  >
                    {cat}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">联系与订阅</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                support@bengou-manga.site
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-500"></i>
                每日 09:00–22:00
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-3">
              {["ri-wechat-fill", "ri-qq-fill", "ri-earth-fill"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50 cursor-pointer"
                >
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 笨狗漫画网 · 追更不迷路，快速找到你想看的漫画
          </p>
          <p className="text-xs text-foreground-500">
            <i className="ri-heart-3-fill text-accent-500"></i> 本站所有漫画内容仅供个人学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}